<template>
  <v-app id="inspire" :key="rerender" role="application" class="ocaAppMain" style="background:rgba(0,0,200,0);" lang="de">
<!--   -->
      <v-container class="justify-center pa-0 pa-lg-5" fluid>

      <v-card class="mx-auto mt-0" max-width="1300" elevation="10">
        <div role="heading">
        <v-row :no-gutters="true">
          <v-col pt-1 pb-1 mt-0 absolute>
            <navigation />
          </v-col>
        </v-row>

          <pictureCarousel />
          <!-- <carouselButton class="pl-4" /> -->

          <v-card-title 
            class="justify-center text-h1; color: rgba(0, 0, 0, 0.6); font-size:20px pb-6 word-wrap"
            align="center"
            justify="center"
          >
            <h1 style="word-break: break-word"> {{ this.results.title }} </h1>
          </v-card-title>
          <v-card-subtitle
            class="text-h2 pb-0"
            align="center"
            justify="center"
          >
         
          <cardSubheader />

          </v-card-subtitle>
          <v-card-text class="mt-4">
            <v-card-actions class="pt-0" >
              <v-layout justify-center >
                <v-btn 
                  :aria-expanded="showButtonToString"
                  aria-controls="desc"
                  icon @click="show = !show"
                  id="descBtn"
                  text
                >
                  <p class="cardButtonText mt-3">{{ $t('jobdesc') }}</p>
                  <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down"  }}</v-icon>
                </v-btn>
              </v-layout>
            </v-card-actions>

            <v-expand-transition class="">
              <div 
                v-show="show"
                id="desc"
              >
                <v-divider class="pt-4" >
                </v-divider>
                <div aria-labelledby="descBtn" class="text" role="region">
                  
                  <jobDescription />

                </div>
                <v-divider class="pb-4"></v-divider>
              </div>
            </v-expand-transition>

          <div role="main" >
            <v-form
              ref="form"
              lazy-validation
              class="pt-8"
            >

      <v-row flex >
        <v-col cols="12" xs="12" sm="6" lg="4">
          <p class="justify-right mb-0">
            {{ $t('mandatory') }}
          </p>
        </v-col>
      </v-row>
      <v-row >
                <v-col 
                  cols="12" xs="12" sm="6" lg="4"
                  v-if="results.templateName != 'Job Requisition SWE'"
                >
                  <v-select
                    :items="salutationArray()"
                    item-text= "text"
                    item-value="value"
                    :label="$t('salutation') + ' *'"
                    required
                    :rules="[
                    (v) => !!v || generateMissingErrorMessage($t('salutation')),
                    ]"
                    v-model="pickedSalutation"
                    aria-describedby="salutation-messages"
                    v-a11y-messages="'salutation-messages'"
                  ></v-select>
                </v-col>

                <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-text-field
                    :label="$t('firstname')+' *'"
                    name="firstName"
                    id="firstName"
                    class="custom-label-color"
                    type="text"
                    :rules="[
                      (v) => !!v || generateMissingErrorMessage($t('firstname')),
                      (v) => !!v && v.length > 1 || $t('firstLonger'),
                      (v) => !!(v || '').match(/^[\u00C0-\u017Fa-zA-Z'][\u00C0-\u017Fa-zA-Z-' ]+$|[-]+$/) || $t('lettersOnly')
                    ]"
                    required
                    v-model="firstName"
                    aria-describedby="firstName-messages"
                    v-a11y-messages="'firstName-messages'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-text-field
                    :label="$t('lastname')+' *'"
                    name="lastName"
                    id="lastName"
                    class="custom-label-color"
                    type="text"
                    :rules="[
                    (v) => !!v || generateMissingErrorMessage($t('lastname')),
                    (v) => !!v && v.length > 1 || $t('lastLonger'),
                    (v) => !!(v || '').match(/^[\u00C0-\u017Fa-zA-Z'][\u00C0-\u017Fa-zA-Z-' ]+$|[-]+$/) || $t('lettersOnly')
                    ]"
                    required
                    v-model="lastName"
                    aria-describedby="lastName-messages"
                    v-a11y-messages="'lastName-messages'"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" xs="12" sm="6" lg="4"
                v-if="results.templateName != 'Job Requisition ROU'"
                >
                  <v-text-field
                    :label="$t('street')+' *'"
                    name="address"
                    id="address"
                    class="custom-label-color"
                    type="text"
                    :rules="[
                    (v) => !!v || generateMissingErrorMessage($t('street')),
                    (v) => !!v && v.length > 1 || $t('streetLonger'),
                    (v) => !v || checkForSpaceOnly(v)
                    ]"
                    required
                    v-model="address"
                    aria-describedby="address-messages"
                    v-a11y-messages="'address-messages'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="6" lg="4"
                v-if="results.templateName != 'Job Requisition ROU'"
                >
                  <v-text-field
                    :label="$t('zip')+' *'"
                    name="zip"
                    id="zip"
                    class="custom-label-color"
                    type="text"
                    :rules="[
                      (v) => !!v || generateMissingErrorMessage($t('zip')),
                      (v) => !v || checkForSpaceOnly(v)
                    ]"
                    required
                    v-model="zip"
                    aria-describedby="zip-messages"
                    v-a11y-messages="'zip-messages'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-text-field
                    :label="$t('city')+' *'"
                    name="city"
                    class="custom-label-color"
                    type="text required"
                    :rules="[
                      (v) => !!v || generateMissingErrorMessage($t('city')),
                      (v) => !v || checkForSpaceOnly(v)
                    ]"
                    required
                    v-model="city"
                    aria-describedby="city-messages"
                    v-a11y-messages="'city-messages'"
                  ></v-text-field>
                </v-col>
              
              <!-- State shall only be applied to the following jobRequisitions: -->
                <v-col cols="12" xs="12" sm="6" lg="4"
                v-if="results.templateName === 'Job Requisition UK' || results.templateName === 'Job Requisition US' || results.templateName === 'Job Requisition CZ'"
                >
                  <v-text-field
                    :label="$t('state')+' *'"
                    name="state"
                    id="state"
                    class="custom-label-color"
                    type="text"
                    :rules="[
                    (v) => !!v || generateMissingErrorMessage($t('state')),
                    (v) => !!(v || '').match(/^[a-zA-Z]+$/) || $t('lettersOnly')
                    
                    ]"
                    required
                    v-model="state"
                    aria-describedby="state-messages"
                    v-a11y-messages="'state-messages'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="6" lg="4"
                >
                  <v-autocomplete
                    :label="$t('country')+' *'"
                    name="country"
                    id="country"
                    v-model="country"
                    :items="countryChoises"
                    item-text="text"
                    item-value="value"

                    class="custom-label-color"
                    :rules="[
                    (v) => !!v || generateMissingErrorMessage($t('country')),
                    (v) => !v || checkForSpaceOnly(v)
                    ]"
                    required
                    aria-describedby="country-messages"
                    v-a11y-messages="'country-messages'"
                  ></v-autocomplete>
                </v-col>

      <!-- </v-row>
              
      <v-row flex class="pt-8"> -->
               <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-text-field
                    :label="$t('tel')+' *'"
                    name="phone"
                    id="phone"
                    class="custom-label-color"
                    type="text"
                    v-model="phone"
                    :rules="[
                    (v) => !!v || generateMissingErrorMessage($t('tel')),
                    (v) => !!(v).match(/^[0-9]+$/) || $t('numbersOnly'),
                    ]"
                    required
                    aria-describedby="phone-messages"
                    v-a11y-messages="'phone-messages'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-text-field
                    :label="$t('mail')+' *'"
                    class="custom-label-color"
                    name="primaryEmail"
                    id="primaryEmail"
                    type="text"
                    autocomplete="off"
                    :rules="[
                    (v) => !!v || generateMissingErrorMessage($t('mail')),
                    (v) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(v) || $t('validMail')
                    ]"
                    required
                    v-model="primaryEmail"
                    aria-describedby="primaryEmail-messages"
                    v-a11y-messages="'primaryEmail-messages'"
                  ></v-text-field>
                </v-col>
             
                <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-text-field
                    id="password"
                    :label="$t('password')+' *'"
                    class="custom-label-color"
                    name="password"
                    required
                    autocomplete="off"
                    v-model="password"
                    :type="showPW ? 'text' : 'password'"
                    :rules="[
                    (v) => !!v || generateMissingErrorMessage($t('password')),
                    (v) => !!v && v.length >= 8 || $t('passwordMoreThan8'),
                    (v) => !!v && v.length <= 18 || $t('password18'),
                    (v) => !!(v || '').match(/(?=.*[a-z])/) || $t('passwordSmallBig'),
                    (v) => !!(v || '').match(/(?=.*[A-Z])/) || $t('passwordSmallBig'),                    
                    (v) => !!(v || '').match(/(.*\d.*)|(.*\W.*)/) || $t('passworgDigitOrSign'),
                    (v) => !!(v || '').match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*$/) || $t('passwordUnicode'),
                    ]"
                    aria-describedby="password-messages"
                    v-a11y-messages="'password-messages'"
                  >
                  <template v-slot:append>
                    <v-icon
                      :aria-pressed="showPW ? 'true' : 'false'"
                      aria-label="show the password"
                      @click="showPW = !showPW"
                    >
                      {{ showPW ? 'mdi-eye' : 'mdi-eye-off' }}
                    </v-icon>
                  </template>

                 <!-- (v) => !!(v || '').match(/(.*\d.*)|(.*\W.*)/) || $t('passwordUnicode'), -->

                  <v-icon
                  class=""
                  slot="append-outer"
                  color="grey"
                  aria-label="Password Explaination"
                  @click="appendIconCallback"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                  
                  </v-text-field>
                </v-col>
      </v-row>

      <v-row class="pt-8">
        <v-col cols="12" xs="12" sm="12" lg="12" v-if="this.$i18n.locale == 'de_DE'">
          <p style="margin-bottom:-80px;font-size: 12px">{{ $t('docCheck') }}</p>
        </v-col>
        <v-col cols="12" xs="12" sm="12" lg="12">
          <p style="margin-bottom: -80px;font-size: 12px">{{ $t('fileTypes') }}</p>
        </v-col>
      </v-row>          

      <v-row class="pt-8">
                <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-file-input
                    outlined
                    chips
                    show-size
                    accept=".pdf, .jpeg, .jpg, .doc, .docx"
                    :placeholder="$t('placeholderCV')"
                    class="custom-label-color"
                    :label="$t('cv')+' *'"
                    append-icon="mdi-paperclip"
                    prepend-icon=""
                    v-model="cvObject"
                    required
                    rounded
                    persistent-hint
                    background-color="grey lighten-5"
                    :rules="[
                      v => !v || v.size < 5000000 || $t('fileSizeError'),
                      v => !!v || $t('cv')+$t('required'),
                    ]"
                    aria-describedby="file-cv-messages"
                    v-a11y-messages="'file-cv-messages'"
                  >
                                      <!--  -->

                                          <!-- v.name.match(/([a-zA-Z0-9\s_\\.\-\(\):])+(.doc|.docx|.pdf|.jpeg|.jpg)$/) || $t('fileExtensionError') -->

                                          <!-- v => !!(v.name || '').match(/([a-zA-Z0-9\s_\\.\-\(\):])+(.doc|.docx|.pdf|.jpeg|.jpg)$/) || $t('fileExtensionError'), -->

                  </v-file-input>
                </v-col>

                <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-file-input
                    outlined
                    chips
                    show-size
                    accept=".pdf, .jpeg, .jpg, .doc, .docx"
                    :placeholder="$t('placeholderCL')"
                    class="custom-label-color"
                    :label="$t('cl')"
                    append-icon="mdi-paperclip"
                    prepend-icon=""
                    v-model="coverLetterObject"
                    rounded
                    persistent-hint
                    background-color="grey lighten-5"
                    :rules="[
                      v =>
                        !v || v.size < 5000000 || $t('fileSizeError'),
                    ]"
                    aria-describedby="file-coverletter-messages"
                    v-a11y-messages="'file-coverletter-messages'"
                  >
                                          <!-- v => !!(v.name || '').match(/([a-zA-Z0-9\s_\\.\-\(\):])+(.doc|.docx|.pdf|.jpeg|.jpg)$/) || $t('fileExtensionError'), -->

                  </v-file-input>
                </v-col>

                  <!--:disabled="miscUploadObject.length > 0" -->
                  <!-- Kann damit nicht initial etwas reinladen; Es muss immer im Array schon was sein, sonst funktioneirt der Button nicht -->

                <v-col cols="12" xs="12" sm="6" lg="4">
                  <v-file-input
                    
                    outlined
                    show-size
                    accept=".pdf, .jpeg, .jpg, .doc, .docx"
                    :placeholder="$t('placeholderMisc')"
                    class="custom-label-color"
                    :label="$t('miscDocs')"
                    append-icon="mdi-paperclip"
                    prepend-icon=""
                    v-model="miscUploadObject"
                    rounded
                    multiple
                    background-color="grey lighten-5"
                    :clearable="false"
                    :rules="[
                    files => 
                      !files || !files.some(file => file.size > 5e6) || $t('fileSizeError'),
                    ]"
                    aria-describedby="file-coverletter-messages"
                    v-a11y-messages="'file-coverletter-messages'"
                  >

                    <!-- !files || files.some(file => !file.name.match(/([a-zA-Z0-9\s_\\.\-\(\):])+(.doc|.docx|.pdf|.jpeg|.jpg)$/) ) || $t('fileExtensionError'), -->

                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      close
                      @click:close="deleteChip(index)"
                    >
                      {{ text }}
                    </v-chip>
                  </template>

                 <v-file-input
                    class="mt-n8"
                    hide-input
                    prepend-icon="mdi-plus"
                    slot="append-outer"
                    :input-props="{ 'aria-label': $t('moreFiles') }"
                    v-model="miscUploadBuffer"
                    accept=".pdf, .jpeg, .jpeg, .doc, .docx"
                    aria-describedby="file-additional-messages"
                    v-a11y-messages="'file-additional-messages'"
                  > </v-file-input>
                </v-file-input>
              </v-col>
      </v-row>

<!-- QUESTIONS -->
<v-row>
<!-- DISABILITY QUESTION (GER + HUN only!) -->
  <v-col cols="12" 
    v-if="conditionDisabilityQuestion" >

        <v-card 
        flat
        class="pl-0 ma-0"
        >
            <v-card-text
            class="pt-0 pl-0 pb-0 pr-0"
            >
              <v-col>
              <v-row class="pb-0" style="display: block;">
                <p class="body-1 text--primary">
                  <!--  Companies may want their own disability text. Thus the text has to be grabbed from the companyConfig instead of the locales tables -->
                  {{ this.companySpecificConfig.disabilityText[this.pickedLanguage] }}
                </p>
                <p class="body-1 text--primary">
                  {{ disabledQuestion.questionText }}
                  <v-icon
                    class=""
                    slot="append-outer"
                    color="grey"
                    aria-label="Disability Explaination"
                    @click="appendDisabledIconCallback"
                    >
                      mdi-help-circle-outline
                  </v-icon>
                </p>
              </v-row>
              <v-row>
                <fieldset style="border: none; padding: 0; margin: 0;">
                  <legend class="sr-only">{{ disabledQuestion.questionText }}</legend>
                  <v-radio-group 
                    class="pt-0, mt-0"
                    v-on:change="changeDisabledAnswer"
                    v-model="disabledAnswer"
                  >
                    <v-radio
                      v-for="i in disabledQuestion.questionChoises"
                      :key="i.value"
                      :label=i.text
                      :value="i.value"
                      class="custom-label-color text-justify"
                    >
                    </v-radio>
                  </v-radio-group>
              </fieldset>  
          </v-row>
        </v-col>
      </v-card-text>
    </v-card>
  </v-col>

  <v-col cols="12" xs="12" sm="6" lg="4"
        v-for="question in questions"
        :key="question.questionOrder"
        class=""
        >

<!-- REQUIRED QUESTIONS -->
        <v-card
        flat
        v-if="question.required == true"
        class="font-weight-regular text-justify"
        >

            <v-card-text 
              class="pt-0 pl-0 pb-0 pr-0 font-weight-regular"

            >
            <v-col>
              <v-row class="pb-0">
                <p 
                  class="body-1 text--primary"
                  id="descBtn"
                  aria-labelledby="descBtn"
                >
                  {{question.questionText + " *"}}
                </p>
              </v-row>
            <v-row>
              <fieldset style="border: none; padding: 0; margin: 0; width: 100%;">
                <legend class="sr-only">{{question.questionText + " *"}}</legend>
                  <!-- MULTIPLE CHOICE QUESTION -->
                <v-select
                  v-if="question.questionType == 'QUESTION_MULTI_CHOICE' && question.questionChoises.length > 3"
                  class="pt-0, mt-0"
                  v-on:change="changeAnswers"
                  v-model="answers[(question.questionOrder)]"
                  required
                    :rules="[
                        v =>
                          v != null || $t('questionRequired')
                      ]"

                      :items="question.questionChoises"
                      item-text= "text"
                      item-value="text"
                  aria-describedby="question-multi-choice-big-messages"
                  v-a11y-messages="'question-multi-choice-big-messages'"

                ></v-select>

                  <v-radio-group 
                          v-else-if="question.questionType == 'QUESTION_MULTI_CHOICE'"
                    class="pt-0 mt-0 body-1 text--primary"
                    v-on:change="changeAnswers"
                    v-model="answers[(question.questionOrder)]"
                    required
                    :rules="[
                        v =>
                          v != null || $t('questionRequired')
                      ]"
                    aria-describedby="question-multi-choice-messages"
                    v-a11y-messages="'question-multi-choice-messages'"
                  >

                    <v-radio
                      v-for="i in question.questionChoises"
                      :key="i.value"
                      :label=i.text
                      :value="i.text"
                      class="choises, custom-label-color text-justify"
                    >

                    </v-radio>
                  </v-radio-group>

                  <!-- RATING QUESTION -->
                  <v-select
                  v-if="question.questionType == 'QUESTION_RATING' && question.questionChoises.length > 3"
                  class="pt-0, mt-0"
                  v-on:change="changeAnswers"
                  v-model="answers[(question.questionOrder)]"
                  required
                    :rules="[
                        v =>
                          v != null || $t('questionRequired')
                      ]"

                      :items="question.questionChoises"
                      item-text= "text"
                      item-value="text"
                  aria-describedby="question-rating-big-messages"
                  v-a11y-messages="'question-rating-big-messages'"

                ></v-select>

                  <v-radio-group 
                    v-else-if="question.questionType == 'QUESTION_RATING'"
                    class="pt-0, mt-0"
                    v-on:change="changeAnswers"
                    v-model="answers[(question.questionOrder)]"
                    required
                    :rules="[
                        v =>
                          v != null || $t('questionRequired')
                      ]"
                    aria-describedby="question-rating-messages"
                    v-a11y-messages="'question-rating-messages'"
                  >

                    <v-radio
                      v-for="i in question.questionChoises"
                      :key="i.value"
                      :label=i.text
                      :value="i.text"
                      class="custom-label-color text-justify"
                    >
                    <!--  :ripple= "false" -->
                    
                    </v-radio>
                  </v-radio-group>

                  <!-- TEXT QUESTION -->
                  <v-textarea
                  v-else-if="question.questionType == 'QUESTION_TEXT'"
                  solo
                  counter
                    class="pt-0, mt-0"
                    v-on:change="changeAnswers"
                    v-model="answers[(question.questionOrder)]"
                    required
                    :rules="[
                        v =>
                          v != null || $t('questionRequired'),
                          (v) => !v || checkForSpaceOnly(v)
                      ]"
                    aria-describedby="question-text-messages"
                    v-a11y-messages="'question-text-messages'"
                  ></v-textarea>

                    <!-- NUMERIC QUESTON -->
                  <v-textarea
                  v-else-if="question.questionType == 'QUESTION_NUMERIC'"
                  solo
                    class="pt-0, mt-0"
                    v-on:change="changeAnswers"
                    v-model="answers[(question.questionOrder)]"
                    rows="1"
                    required
                    :rules="[
                    v =>
                      v != null || $t('questionRequired'),
                      (v) => !!(v).match(/^[0-9.]+$/) || $t('useDot'),
                      ]"
                    aria-describedby="question-numeric-messages"
                    v-a11y-messages="'question-numeric-messages'"
                  ></v-textarea>
                </fieldset>
              </v-row>
            </v-col>
          </v-card-text>
        </v-card>

<!-- OPTIONAL QUESTIONS -->
        <v-card 
        v-else
        flat>
            <v-card-text class="pt-0 pl-0 pb-0" >
              <v-col>
              <v-row class="pb-0">
                <p class="body-1 text--primary" >
                  {{question.questionText}}
                </p>
              </v-row>

              <v-row>
                <fieldset style="border: none; padding: 0; margin: 0; width: 100%;">
                <legend class="sr-only">{{question.questionText}}</legend>
                
<!-- MULTI CHOISE QUESTION -->
                <v-select
                  v-if="question.questionType == 'QUESTION_MULTI_CHOICE' && question.questionChoises.length > 3"
                  class="pt-0, mt-0"
                  v-on:change="changeAnswers"
                  v-model="answers[(question.questionOrder)]"

                      :items="question.questionChoises"
                      item-text= "text"
                      item-value="text"


                    ></v-select>

                <v-radio-group 
                    v-else-if="question.questionType == 'QUESTION_MULTI_CHOICE'"
                    class="pt-0, mt-0"
                    v-on:change="changeAnswers"
                    v-model="answers[(question.questionOrder)]"
                    
                  >

                    <v-radio
                      v-for="i in question.questionChoises"
                      :key="i.value"
                      :label=i.text
                      :value="i.text"
                      class="custom-label-color text-justify"
                    >
                    </v-radio>
                  </v-radio-group>

<!-- RATING QUESTION -->
                  <v-select
                  v-if="question.questionType == 'QUESTION_RATING' && question.questionChoises.length > 3"
                  class="pt-0, mt-0"
                  v-on:change="changeAnswers"
                  v-model="answers[(question.questionOrder)]"

                      :items="question.questionChoises"
                      item-text= "text"
                      item-value="text"

                    ></v-select>

                  <v-radio-group 
                    v-else-if="question.questionType == 'QUESTION_RATING'"
                    class="pt-0, mt-0"
                    v-on:change="changeAnswers"
                    v-model="answers[(question.questionOrder)]"
                    
                  >

                    <v-radio
                      v-for="i in question.questionChoises"
                      :key="i.value"
                      :label=i.text
                      :value="i.text"
                      class="custom-label-color text-justify"
                    >
                    
                    </v-radio>
                  </v-radio-group>

<!-- TEXT QUESTION -->
                  <v-textarea
                  v-else-if="question.questionType == 'QUESTION_TEXT'"
                  solo
                  counter
                    class="pt-0, mt-0"
                    v-on:change="changeAnswers"
                    v-model="answers[(question.questionOrder)]"
                    aria-describedby="question-opt-text-messages"
                    v-a11y-messages="'question-opt-text-messages'"
                  ></v-textarea>

<!-- NUMERIC QUESTON -->
                  <v-textarea
                  v-else-if="question.questionType == 'QUESTION_NUMERIC'"
                  solo
                    class="pt-0, mt-0"
                    v-on:change="changeAnswers"
                    v-model="answers[(question.questionOrder)]"
                    rows="1"
                    :rules="[
                      v => (!v || (!!v && !!v.match(/^[0-9.]+$/))) || $t('useDot')
                      ]"
                    aria-describedby="question-opt-numeric-messages"
                    v-a11y-messages="'question-opt-numeric-messages'"
                  ></v-textarea>
                </fieldset>  
              </v-row>
            </v-col>
          </v-card-text>
        </v-card>
  </v-col>
       
<!-- SYSTEM VISIABILITY QUESTION -->
  <v-col cols="12" xs="12" sm="6" lg="4"> 
    <v-card 
        flat
        class="pl-0 ma-0"
        >
          <v-card-text class="pt-0 pl-0 pb-0 pr-0" >
              <v-col>
              <v-row class="pb-0">
                <p class="body-1 text--primary" >
                  {{$t('visibility') + ' *'}}
                </p>
              </v-row>
                <v-row>
                  <fieldset style="border: none; padding: 0; margin: 0; width: 100%;">
                    <legend class="sr-only">{{$t('visibility') + ' *'}}</legend>
                    <v-radio-group 
                      class="pt-0, mt-0"
                      v-model="visibility"
                      required
                      :rules="[(v) => !!v || $t('questionRequired')]"
                      aria-describedby="question-visibility-messages"
                      v-a11y-messages="'question-visibility-messages'"
                    >

                    <v-radio
                      :label="$t('visibilityOption0')"
                      value="0"
                      class="choises, custom-label-color text-justify"
                    ></v-radio>
                    <v-radio
                      :label="$t('visibilityOption1')"
                      value="1"
                      class="choises, custom-label-color text-justify"
                    ></v-radio>
                    <v-radio
                      :label="$t('visibilityOption2')"
                      value="2"
                      class="choises, custom-label-color text-justify"
                    ></v-radio>
                  <!--  :ripple= "false" -->
                    </v-radio-group>
                  </fieldset>
                </v-row>
              </v-col>
            </v-card-text>
      </v-card>
    </v-col>

  <!-- SPECIAL QUESTION ROMANIA 1 (RO only!) -->
  <v-col cols="12" xs="12" sm="6" lg="4" 
    v-if="this.results.templateName === 'Job Requisition ROU'" >

        <v-card 
        flat
        class="pl-0 ma-0"
        >
            <v-card-text
            class="pt-0 pl-0 pb-0 pr-0"
            >
              <v-col>
              <v-row class="pb-0" style="display: block;">
                <p class="body-1 text--primary">
                  {{ this.results.romanianQuestion.questionText + ' *'}}
                </p>
              </v-row>
              <v-row>
                <fieldset style="border: none; padding: 0; margin: 0; width: 100%;">
                  <legend class="sr-only">{{ this.results.romanianQuestion.questionText + ' *'}}</legend>
                  <v-select
                    class="pt-0, mt-0"
                    v-on:change="changeRomanianAnswer"
                    v-model="romanianAnswer"
                    required
                    :rules="[(v) => !!v || $t('questionRequired')]"
                    aria-describedby="question-romanian-messages"
                    v-a11y-messages="'question-romanian-messages'"

                    :items="this.results.romanianQuestion.questionChoises"
                    item-text= "text"
                    item-value="value"
                  ></v-select>
                </fieldset>
          </v-row>
        </v-col>
      </v-card-text>
    </v-card>
  </v-col>

</v-row>

<!-- PRIVACY DIALOG -->
  <v-checkbox class="pt-8"
        v-model="agreement"
        :rules="[(v) => !!v || $t('questionRequired')]"
        aria-describedby="privacy-checkbox-messages"
        v-a11y-messages="'privacy-checkbox-messages'"
      >
        <template v-slot:label>
          <a
            href="#"
            @click.stop.prevent="dialog = true"
          > {{ $t('privacyBut') }} </a> 
        </template>
  </v-checkbox>
      
<!-- LEGAL DIALOG -->
  <v-dialog
      v-model="dialog"
      absolute
      max-width="800"
      persistent
    >
      <v-card
      role="dialog"
      aria-labelledby="dialog1Title"
      aria-describedby="dialog1Desc"
      >
        <v-card-title 
        class="headline grey lighten-3"
        id="dialog1Title"
        >
          {{ $t('privacyHeader') }}
        </v-card-title>
        <v-card-text
        id="dialog1Desc"
        tabindex="0"
        role="region"
        >
          <div
            v-html="privacyHTML">
          </div>
          </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            text
            @click="agreement = false, dialog = false"
          >
           {{ $t('no') }}

          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="green"
            @click="agreement = true, dialog = false"
          >
            {{ $t('yes') }}

          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>

<!-- PASSWORD DIALOG -->
  <v-dialog
      v-model="passwordExplaination"
      max-width="800"
    >
    <v-card
      aria-modal="true"
      role="dialog"
      aria-labelledby="dialog1Title"
    >
        <v-card-text class="pt-4 pb-4">
          
          <h2 
          class="d-sr-only"
          id="dialog1Title"
          >{{$t('passwordDialogHeader')}}</h2>
          
          <div
          role="region"
          v-html="$t('passwordText')">
          </div>
           
          </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
        class="justify-center"
        >
          <v-btn
            justify-center
            @click="passwordExplaination = false"
            class="white--text "
            color="green"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>

<!-- DISABLED DIALOG -->
<v-dialog
      v-model="disabledSecondText"
      max-width="800"
    >
    <v-card
      aria-modal="true"
      role="dialog"
      aria-labelledby="dialog1Title"
    >
        <v-card-text class="pt-4 pb-4">
          
          <h2 
          class="d-sr-only"
          id="dialog1Title"
          ></h2>
          
          <div
          role="region"
          v-html="$t('disableSecondText')">
          </div>
           
          </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
        class="justify-center"
        >
          <v-btn
            justify-center
            @click="disabledSecondText = false"
            class="white--text "
            color="green"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>

<!-- CAPTCHA -->
  <v-row class="pb-4 pt-4">
    <v-col>
      <v-row           
        class="justify-center"
        align="center"
        justify="center">
          <mtCaptcha /> 
        </v-row>
<!-- SUBMIT BUTTON -->
<v-row
class="justify-center pb-4 pt-4"
    align="center"
    justify="center">

      <v-card-actions
        class="justify-center"
        >
              <v-btn
                color="primary"
                :disabled="!valid"
                x-large
                elevation="6"
                @click="
                  validate();
                "
                >{{$t('applyNow')}}</v-btn
              >
            </v-card-actions>
</v-row>
          </v-col>
        </v-row>

            <!-- /Overlay-Element -->
            <v-overlay :value="overlay">

              <v-progress-circular
                v-show="progresscicle"
                indeterminate
                size="64"
              ></v-progress-circular>

            <!-- SUCCESS -->
            <!-- sfData was reachable. Does not mean, that sending application was successful! -->
              <successalert 
                v-show="success"
              />

            <!-- FAILURE -->
              <v-alert type="error" v-show="failure">
                <p>
                {{ $t('failure')}} <br>
                {{ this.sfDataResponse }}
                </p>
                <v-btn
                  @click="overlay = false; failure = false;"
                  >
                  {{ $t('continue') }}
                  </v-btn
                >
              </v-alert>
            </v-overlay>

          <v-row class="pt-8">
             <v-col cols="12">
              <p>
               Copyright EON HR IT
              </p>

             </v-col>
          </v-row>
        </v-form>
      </div>
    </v-card-text>
  </div>
</v-card>

<!-- Erst validate(), hier soll dann aus dem if der Call gegen sfData erfolgen -->

    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import successalert from "../components/successalert"
import pictureCarousel from "../components/pictureCarousel"
import navigation from "../components/toolbar2.vue"
import jobDescription from "../components/jobDescription.vue"
import cardSubheader from "../components/cardSubheader.vue"
import mtCaptcha from '../components/mtCaptcha.vue'

export default {
  data() {
    // TODO: Wenn keine LANG mitgegeben und der Server die Lang switched, muss reload +1 durchgeführt werden. Ansonsten bleiben die Fehlermeldungen auf Englisch
    // => Wenn SF-Sprache da, mache immer einen Componenten-Refresh (nur um sicher zu sein)
    // Abfrage: 
    // Anschreiben Möglichkeit freiwillig
    // Abfrage Schwerbehinderung inkl. kleinen Text; freiwilliger Angabe
    // durchlaufende Bilder

    return {
      valid: true,
      show: false,
      checkbox: false,
      terms: false,
      agreement: false,
      passwordExplaination: false,
      disabledSecondText: false,
      dialog: false,
      cv64: undefined,
      misc64: undefined,
      coverletter64: undefined,
      showPW: false,
      referredBy: undefined,
      postingCompany: undefined,
      renderCount: 0,
      errorStates: {
        firstName: false,
        lastName: false,
        // Add other fields as needed
      },
      firstNameRules: [
        v => !!v || this.generateMissingErrorMessage(this.$t('firstname')),
        v => !!v && v.length > 1 || this.$t('firstLonger'),
        v => !!(v || '').match(/^[\u00C0-\u017Fa-zA-Z'][\u00C0-\u017Fa-zA-Z-' ]+$|[-]+$/) || this.$t('lettersOnly')
      ]
    };
  },

  props: {
    source: String,
  },

  created() {
    this.overlay = true



    //Array, [0] = system, [1] = reqId, [2] = lang
    let queries = this.getQueriesForOCACall()
    let queryTalentry = this.getQueriesForTalentry()
    let postingCompany = this.getQueryPostingCompany()

    //sets the language acording to the string in the query. if not given or language code ist not found english as default
    //Has to occour before calling the SF GET function in order to call a correct language
    //queries 1 is the language value

    this.system = queries[0]
    this.reqId = queries[1]
    this.setLanguage(queries[2])
    this.referredBy = queryTalentry
    this.postingCompany = postingCompany

    //Gets the requested reqId data from sfData. Language needs to be settet before, else en_US will be fetched
    //ISSUE: Do not wait for the future here to resolve
    this.getPostFromStore(queries, postingCompany)

    // iPhone v-fileinput fix
    let inputs = document.querySelectorAll(".v-file-input input");
    [...inputs].forEach((input) => {
      input.remove();
    });

    this.overlay = false
    
  },

  mounted() {
    self.overlay = false
    self.failure = false
    self.success = false
  },

  components: {
    successalert,
    pictureCarousel,
    navigation,
    jobDescription,
    cardSubheader,
    mtCaptcha
  },
  
  directives: {
    a11yMessages: {
      inserted(el, binding) {
        const messagesContainer = el.querySelector('.v-messages');
        if (messagesContainer) {
          messagesContainer.id = binding.value;
          messagesContainer.removeAttribute('role');
        }
      },
      update(el, binding) {
        const messagesContainer = el.querySelector('.v-messages');
        if (messagesContainer) {
          messagesContainer.id = binding.value;
          messagesContainer.removeAttribute('role');
        }
      }
    }
  },

  computed: {

    conditionDisabilityQuestion() {
      if ((this.results.templateName === 'Job Requisition GER') ||
          (this.results.templateName === 'Job Requisition Westnetz') || 
          (this.results.templateName === 'Job Requisition Hansewerk / E.DIS') || 
          (this.results.templateName === 'Job Requisition EDN, Avacon, EKN') || 
          (this.results.templateName === 'Job Requisition E.ON Gesellschaften / PEL') || 
          (this.results.templateName === 'Job Requisition Bayernwerk') || 
          (this.results.templateName === 'Stellenanforderung MINT Projekt') || 
          (this.results.templateName === 'Job Requisition HUN')
          ) {
        return true
      } else {return false}
    },

  results() { return this.$store.state.results; },

  overlay: { 
      get () {  return this.$store.state.overlay },
      set(value) { this.$store.commit('toggleOverlay', value) } },

  progresscicle: { 
      get () {  return this.$store.state.progresscicle },
      set(value) { this.$store.commit('toggleProgressCicle', value) } },

  firstName: {
    get () { return this.$store.state.firstName },
    set (value) { this.$store.commit('updateFirstName', value) } },

  lastName: { 
    get () { return this.$store.state.lastName },
    set (value) { this.$store.commit('updateLastName', value) } },
  
  pickedSalutation: {
    get () { return this.$store.state.salutation },
    set (value) { this.$store.commit('updateSalutation', value) } },

  phone: { 
    get () { return this.$store.state.phone },
    set (value) { this.$store.commit('updatePhone', value) } },

  primaryEmail: {
    get () { return this.$store.state.primaryEmail },
    set (value) { this.$store.commit('updatePrimaryEmail', value) } },

  city: {
    get () { return this.$store.state.city },
    set (value) { this.$store.commit('updateCity', value) } },

  zip: { 
    get () { return this.$store.state.zip },
    set (value) { this.$store.commit('updateZip', value) } },

  state: 
    { get () { return this.$store.state.state },
    set (value) { this.$store.commit('updateState', value) } },

  country: 
    { get () { return this.$store.state.country },
    set (value) { this.$store.commit('updateCountry', value) } },

  address: 
    { get () { return this.$store.state.address },
    set (value) { this.$store.commit('updateAddress', value) } },

  password: 
    { get () { return this.$store.state.password },
    set (value) { this.$store.commit('updatePassword', value) } },

  cvObject: { 
    get () { return this.$store.state.cvObject },
    set (value) { this.$store.commit('updateCVObject', value) } },

  coverLetterObject: {
    get () { return this.$store.state.coverLetterObject },
    set (value) { this.$store.commit('updateCoverLetterObject', value) } },

  system: {
    get () { return this.$store.state.system },
    set (value) { this.$store.commit('updateSystem', value) } },

  reqId: {
    get () { return this.$store.state.reqId },
    set (value) { this.$store.commit('updateReqId', value) } },

  privacyHTML: {
    get () { return this.$store.state.privacyHTML } },
    
  miscUploadBuffer: {
    get(){return []},
    set (file) { 
      
      let currentFiles = this.miscUploadObject
      
      if (currentFiles) { 
        currentFiles.push(file)
        this.miscUploadObject = currentFiles
      } else { this.miscUploadObject = [file] }
    }
  },

  miscUploadObject: {
    get () { return this.$store.state.miscUploadObject },
    set (value) { this.$store.commit('updateMiscUploadObject', value) } },

  success: { 
    get () { return this.$store.state.success },
    set (value) { this.$store.commit('toggleSuccess', value) } },

  failure: { 
    get () { return this.$store.state.failure },
    set (value) { this.$store.commit('toggleFailure', value) } },

  sfDataResponse: {
    get () { return this.$store.state.sfDataResponse },
    set (value) { this.$store.commit('updatesfDataResponse', value) }
    },

  SFResponse: {
    get () { return this.$store.state.SFResponse },
    set (value) { this.$store.commit('updateSFResponse', value) }
    },

    // QUESTIONS TEST

  questions: { get () { return this.$store.state.results.questions  } },

  answers: { 
    get () { return this.$store.state.answers },
    set ( value ) { this.$store.commit('updateAnswers', value) } },

  disabledQuestion: { get () { return this.$store.state.results.disabledQuestion }},

  countryChoises: { get () { return this.$store.state.results.countryAnswers }},

  disabledAnswer: { 
    get () { return this.$store.state.disabledAnswer },
    set ( value ) { this.$store.commit('updateDisabledAnswer', value) } },

  romanianAnswer: { 
    get () { return this.$store.state.romanianAnswer },
    set ( value ) { this.$store.commit('updateRomanianAnswer', value) } },

  visibility: { 
    get () { return this.$store.state.visibility },
    set ( value ) { this.$store.commit('updateVisibility', value) } 
    },
  //Da Vue bei V-Bind bei einem Bool immer den tag bei false entfernt und das beim descBtn nicht erwünscht hier die Formatierung zu einem String
  showButtonToString: {
    get () {
      let bool = this.show.toString()
      return bool
    }
  },

// TECH STUFF
  rerender: {
      get() { 
        return this.$store.state.rerender
        }
    },
  availableLanguages: {
      get() { return this.$store.state.availableLanguages }
    },
  pickedLanguage: {
      get() { return this.$store.state.pickedLanguage }
    },
  companySpecificConfig: {
      get() { return this.$store.state.companySpecificConfig }
    },
  templateName: {
      get() { return this.$store.state.templateName }
    }
  },

// https://vue-meta.nuxtjs.org/api/#meta
  metaInfo() {
      return {
        title: this.results.title,
        // link: [
        //   { rel: 'stylesheet', href: '/css/index.css' },
        //   { rel: 'favicon', href: 'favicon.ico' }
        //   ]
      }
    },

  methods: {

    //ROU needs the fie
    generateMissingErrorMessage(field) {
      if(this.results.templateName === "Job Requisition ROU" && field === "Formulă de adresare" || field === "Localitatea" || field === "Țara" || field === "Adresă de e-mail" || field === "Parola") {
          return this.$t(field)+" este obligatorie"
      } else {
        return this.$t(field)+this.$t('required')
      }
    },

    checkForSpaceOnly(field){
      const trimmed = field.trim();
      if(trimmed.length == 0){
        return this.$t(field)+" " + this.$t('space')
      }        
    },  

    grabDisabilityIntroText() {
      return this.companySpecificConfig.disabilityText[this.pickedLanguage]
    },

    salutationArray() {
      let returnArray = [
        {
          text: this.$t('male'),
          value: "m"
        },
        {
          text: this.$t('female'),
          value: "f"
        },
        {
          text: this.$t('noPick'),
          value: "na"
        }
      ]

      if (((this.results.templateName === 'Job Requisition GER') ||
          (this.results.templateName === 'Job Requisition Westnetz') || 
          (this.results.templateName === 'Job Requisition Hansewerk / E.DIS') || 
          (this.results.templateName === 'Job Requisition EDN, Avacon, EKN') || 
          (this.results.templateName === 'Job Requisition E.ON Gesellschaften / PEL') || 
          (this.results.templateName === 'Job Requisition Bayernwerk') || 
          (this.results.templateName === 'Stellenanforderung MINT Projekt')) //|| 
          // (this.results.templateName === 'Job Requisition HUN')
          && this.$t('diverse') != null) {

          returnArray.push(
            {
              text: this.$t('diverse'),
              value: "d"
            }
          )
      }

      return returnArray

    },

    deleteChip(index) {
      this.$store.dispatch("deleteAdditionalDocument", index)
    },
    getQueriesForOCACall() {
      return this.$route.query.reqId.split('-')
    },
    getQueriesForTalentry() {
      return this.$route.query.referredBy
    },
    getQueryPostingCompany() {
      return this.$route.query.postingCompany
    },
    changeDisabledAnswer() {
        var buffer = this.disabledAnswer
        this.disabledAnswer = buffer
    },  
    changeRomanianAnswer() {
      var buffer = this.romanianAnswer
      this.romanianAnswer = buffer
    },  

    validate() {

      console.log("Testtextvalidate")


        var some = this.$refs.form.validate()

        if (!some) {
          this.$nextTick(() => {
            const firstError = this.$refs.form.inputs.find(input => input.hasError);
            if (firstError) {
                // v-select uses a div[role="button"] as its interactive target;
              // focusing the inner readonly input instead would trigger :focus-within
              // on the slot and leave the field visually stuck with an outline.
              const focusable =
                firstError.$el.querySelector('.v-input__slot[role="button"]') ||
                firstError.$el.querySelector('input:not([type="hidden"]), textarea');
              if (focusable) focusable.focus();
            }
          });
        }

        if (window.mtcaptcha.getVerifiedToken()) {
        if (some) {
          
          this.overlay = true;
          this.progresscicle = true;
          console.log('posting started')

          
          console.log(this.$store)
          this.postApplication()

        } else { console.log('ALERT') }
      } else {
        window.mtcaptcha.showMandatory()
      }
    },
    appendIconCallback () {
        this.passwordExplaination = true
      },
    appendDisabledIconCallback () {
        this.disabledSecondText = true
      },

    //TODO: Das ist bescheiden, weil: Nur bei einem Reload der Komponente wird das berechnet. 
    //D.h. ändert sich Screensize und es findet kein rerender der Komponente statt, bleibt alles wie es ist
    // onWindowResized() {
    //   let textareaWidth = this.$refs.container && this.$refs.container.offsetWidth;
    //   if (textareaWidth !== this.textareaWidth) {
    //     this.textareaWidth = textareaWidth;
    //     this.$refs.textarea.calculateInputHeight();
    //   }
    // },
    
    //Reads the 'CV' file and parses it into base64 into this views data. This base64 string is then used in the payload
    cvLoader(file){
            var vue = this;
                return new Promise(function(resolve,reject){
                    let reader = new FileReader();

                    reader.onloadend = function(){
                        var theNewOne = reader.result.replace(/^data:.+;base64,/, "");
                        vue.cv64 = theNewOne
                        resolve(theNewOne);
                    };

                    reader.onerror = function(){
                        reject(reader);
                    };

                    reader.readAsDataURL(file);
                });
        },
    //Reads the 'CoverLetter' file and parses it into base64 into this views data. This base64 string is then used in the payload
    clLoader(file){
              var vue = this;
                return new Promise(function(resolve,reject){
                    let reader = new FileReader();

                    reader.onloadend = function(){
                        var theNewOne = reader.result.replace(/^data:.+;base64,/, "");
                        vue.coverletter64 = theNewOne
                        resolve(theNewOne);
                    };

                    reader.onerror = function(){
                        reject(reader);
                    };

                    reader.readAsDataURL(file); 

                });
        },
        //Reads the 'Misc Documents' file and parses it into base64 into this views data. This base64 string is then used in the payload
      miscLoader(file){
              let vue = this;
              return new Promise(function(resolve,reject){

                  //Hier ist ein Array. Für jeden 
                  let returnarray = []
                  let cycleCount = 0

                  file.forEach(i => {
                    let reader = new FileReader();

                    reader.onloadend = function(){

                      let object = {
                        miscName: i.name,
                        miscDoc: reader.result.replace(/^data:.+;base64,/, "")
                      }

                      returnarray.push(object)
                      cycleCount += 1
                      if (cycleCount == file.length) {
                        vue.misc64 = returnarray
                        resolve(returnarray)
                      }
                    }

                    reader.onerror = function(){
                      reject(reader);
                    };

                    reader.readAsDataURL(i);
                  
                })
        })
      },
      updateErrorState(field, hasError) {
        this.errorStates[field] = hasError;
      },

    //Checks for the payload if given file is available. 
    //If yes, async parsing into base64 is started. Because the parsing needs to be done before trying to send it
    parseUploadFiles() {

      let vue = this;

      return new Promise(function(resolve, reject){

      //Check CV
      if (vue.cvObject !== undefined) {
        // console.log(1)
        return vue.cvLoader(vue.cvObject)
      //Check Misc documents
      .then(() => {
        if (vue.miscUploadObject.length != 0) {
          // console.log(2)
          return vue.miscLoader(vue.miscUploadObject)
        }
      })
      //Check Coverletter
      .then(() => {
        if (vue.coverLetterObject != undefined) {
          // console.log(3)
          return vue.clLoader(vue.coverLetterObject)
        }
      })
      .then(() => {
        resolve(true);
      })
    }
    else { reject('parseUploadFiles: CV object could not get parsed') }
    })
  },

    postApplication() {
                                                                                                                                                                                                                                                                                                                                                                                                                               
      let vue = this;
      // let loadreqId = this.$route.query.reqId.split('-')[1]
      
      //get source tracking
      const utmSource = this.$route.query.utm_source;

    this.parseUploadFiles().then(() => {

        let upsertStruct = {
          reqId: vue.reqId,
          firstName: vue.firstName,
          lastName: vue.lastName,
          salutaiton: vue.pickedSalutation,
          phone: vue.phone,
          primaryEmail: vue.primaryEmail,
          city: vue.city,
          zip: vue.zip,
          state: vue.state,
          address: vue.address,
          password: vue.password,
          country: vue.country,
          dsgvo: vue.agreement.toString(),
          answers: vue.answers,
          disableAnswer: vue.disabledAnswer,
          romanianAnswer: vue.romanianAnswer,
          locale: vue.pickedLanguage,
          visibility: vue.visibility,
          captchaToken: window.mtcaptcha.getVerifiedToken(),
          system: vue.system,
          referredBy: vue.referredBy,
          templateName: vue.results.templateName,
          sourceTracking: utmSource
        };

        // If there are questions in the middle that did not get answered, the array at this index will stay undefined
        // To process this correctly for the backend, every undefined value shall be replaced by an empty string
        for (const [index] of upsertStruct.answers.entries()) {
          // console.log(index)
          if (typeof upsertStruct.answers[index] == 'undefined' && upsertStruct.answers[index] !== 0) {
            upsertStruct.answers[index] = ""
          }
        }

        console.log(upsertStruct)
        

        //Pobbsible that the file was removed after a first attempt to apply but the base64 is still there. Thus we also check, if the VueX file is still available.
        //If yes, then the base64 value will get used in the payload with the name of the document from the VueX file
        if (vue.cv64 != null && vue.cvObject != undefined) {
          upsertStruct["cv"] = vue.cv64
          upsertStruct["cvName"] = vue.cvObject.name
        }
        if (vue.coverletter64 != null && vue.coverLetterObject != undefined) {
          upsertStruct["cl"] = vue.coverletter64
          upsertStruct["clName"] = vue.coverLetterObject.name
        }
        if (vue.misc64 != null && vue.miscUploadObject.length != 0) {
          upsertStruct["miscDocs"] = vue.misc64
          upsertStruct["miscName"] = vue.miscUploadObject.name
        }

        console.log(upsertStruct)

        

        let url = ""

        if (process.env.NODE_ENV == "development") {
          url = "http://localhost:8080/oca/postApplication";
        } else {
          var scheme = window.location.protocol;
          var host = window.location.hostname;
          var port = window.location.port;
          url = scheme + "//" + host + ":" + port + "/oca/postApplication";
        }

        axios
          .post(url, upsertStruct)
          .then((response) => {

            console.log(response.data)
            vue.setSFResponse(response.data)
            vue.progresscicle = false
            vue.success = true

            if (vue.results.templateName == "Job Requisition SWE" && response.data.status != "ERROR"){

            let metaScript= document.createElement('script')
            metaScript.setAttribute('src', '/assets/jobtipTrackingSuccessPage.js#/')
            document.head.appendChild(metaScript)
            console.log("Tracker2")

          }
            
          })
          .catch((error) => {
            vue.progresscicle = false
            vue.success = false
            vue.failure = true

            if (typeof error.response?.data?.reason !== 'undefined') {
              let reason = error.response.data.reason
              //Kandidaten-Fehler hier parsen. Und mit einem i18n-Text wiedergeben

              vue.setsfDataResponse(reason)
              
            } else {
              vue.setsfDataResponse(vue.$t('serverFailure'))
            }
        });
    })
    .catch((error) => {
      vue.progresscicle = false
      vue.success = false
      vue.failure = true
      vue.setsfDataResponse(error.response.data.reason)
      
      console.log(error)
    })
  },

  checkFileAvailability() {},

    getPostFromStore(queries, postingCompany) {

      let url = ""
    
      let querySystem = queries[0]
      let queryReqId = queries[1]
      let queryLanguage = queries[2]

        if (process.env.NODE_ENV == "development") {
          url = "http://localhost:8080/oca/data?reqId=" + queryReqId + "&system=" + querySystem + "&lang=" + queryLanguage

          if (postingCompany !== undefined) {
            url = url + "&postingCompany=" + postingCompany
          }

        } 
        else {
          let scheme = window.location.protocol;
          let host = window.location.hostname;
          let port = window.location.port;
          url = scheme + "//" + host + ":" + port + "/oca/data?reqId=" + queryReqId + "&system=" + querySystem + "&lang=" + queryLanguage;

          if (postingCompany !== undefined) {
            url = url + "&postingCompany=" + postingCompany
          }

        }

      this.$store.dispatch("getPost", url)
        .then(() => this.$i18n.locale = this.pickedLanguage)
    },

    setsfDataResponse(response) {
      window.mtcaptcha.resetUI()
      this.sfDataResponse = response
    },
    getsfDataResponse(){
      return this.sfDataResponse
    },
    setSFResponse(response) {
      this.SFResponse = response
      //Ist das SF Objekt. this.message sollte die Nachricht holen
    },
    getSFResponse(){
      return this.SFResponse
    },

    // QUESTIONS TEST
    changeAnswers() {
        var buffer = this.answers

        buffer.forEach(function (item) {
          if (item == undefined) {
            item = ""
          }
        })
        this.answers = buffer
      },

    setLanguage(langQuery) {
      //Check if empty. When empty or wrong, en_GB is currently set as default and fallback

if(langQuery != undefined) {

        //Checks if this query is valid for i18n. Could be that there is unsinn inside. The SF Call can override the availableLanguages array with the langugaes available for the 
        //requested jobReq. Since these Strings are delivered serverside, I can trust that there is no unsinn inside them 
        for (const i of this.availableLanguages) {
          if ( i == langQuery ) {
            this.$i18n.locale = langQuery
          } 
        }
      } else { this.$i18n.locale = "en_GB" }
    },
  },
};
</script>

<style>

  h1{
    font-size:28px;
    /* color: #424242!important; */
    }

  h2{
    font-size:16px; 
    font-weight: normal;
    /* color: #616161!important; */
    line-height: 100%
    }

  .v-messages__message{
    font-size:14px; 
  }

.v-application .font-weight-medium {
  color: #585858!important;
}

  .custom-label-color .v-label {
  color: #585858!important;
  opacity: 1;
  font-size: 16px;
}
.theme--light.v-application .text--primary {
    color: #585858!important;
  opacity: 1;
  font-size: 16px!important;
}

.v-card__subtitle {
  color:#585858!important;
}

.theme--light.v-btn.v-btn--icon {
  color:#585858!important;
  font-weight: normal;
  font-size:16px;
  letter-spacing: -.0083333333em; 
}
.theme--light.v-icon {
    color:#585858!important;
}

.error--text {
  font-size:16px;
}

.choices ::v-deep legend {
  height: unset !important;
}

.grecaptcha-badge { display: none; }

.cardButtonText { text-transform: none; }

.v-text-field .v-messages {

}

</style>
